import './styles/index.css';

import './js/anims';
import './js/menu';
import './js/no-widows';
import './js/topbar';
import './js/smoothscroll';
import './js/cookie-consent';

// if (document.querySelector("[data-target]")) {
//   import('./js/smoothscroll').then(({ initSmoothScroll }) => {
//     initSmoothScroll();
//   });
// }

if (document.querySelector("#contact-form")) {
  import('./js/contact-form').then(({ initContactForm }) => {
    initContactForm();
  });
}
